import HttpRequest from './axios'
import config from './config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.eatingConfig.baseUrl.dev : config.eatingConfig.baseUrl.pro

const axios = new HttpRequest(baseUrl)
export default axios